module.exports = __webpack_public_path__ + "img/956389491.3afa8b71.jpg";